import { RibbonSplitButtonProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { AppSplitButtonProps } from '@1js/acui-button/lib/components/AppSplitButton/AppSplitButton.Props';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import type { AppControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/AppControlProps';

export function convertRibbonControlToAppControl(
    ribbonControl: RibbonControlProps
): AppControlProps {
    const result = ribbonControl as AppSplitButtonProps;
    const rbnCtrl = ribbonControl as RibbonSplitButtonProps;
    if (rbnCtrl?.iconSet?.default) {
        const controlIcon = rbnCtrl?.iconSet?.default;
        result.icon = controlIcon;
    }
    return result;
}
